import NotificationState from '@/interfaces/State/NotificationState'

export const state: NotificationState = {
	notifications: [],
	showSpoofing: false
}
